import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=d1a4e1be&scoped=true&"
var script = {}
import style0 from "./welcome.vue?vue&type=style&index=0&id=d1a4e1be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a4e1be",
  null
  
)

export default component.exports